import { render, staticRenderFns } from "./DeleteAdvertiserButton.vue?vue&type=template&id=cb87217a&"
import script from "./DeleteAdvertiserButton.vue?vue&type=script&lang=ts&"
export * from "./DeleteAdvertiserButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports